import * as _4 from 'lodash4';
import { ORM } from 'utility-ts-orm';
import { PollAnswerDataStore } from '../datastore/poll_answer_datastore';
import { PollDataStore } from '../datastore/poll_datastore';
import { PollStudentDataStore } from './../datastore/poll_student_datastore';
import { PollResultsServant } from './../servants/poll_results_servant';

export class PollResultsQueryModel {
  private _result: any;
  private _resourceIds: Array<number | string>;
  private _showResults: {
    hasResources: boolean;
    showResults: boolean;
  };

  constructor(
    private ngPollAnswerDataStore: PollAnswerDataStore,
    private ngPollDataStore: PollDataStore,
    private ngPollStudentDataStore: PollStudentDataStore,
    private ngPollResultsServant: PollResultsServant
  ) {
    ORM.registerQuery(this, this.ngPollDataStore, this.ngPollAnswerDataStore);
    this._result = {};
    this._resourceIds = [];
    this._showResults = {
      hasResources: false,
      showResults: false
    };
  }

  run(): any {
    this._result = this.ngPollResultsServant.buildPoll(
      this.ngPollDataStore.read(),
      this.ngPollAnswerDataStore.read(),
      this.ngPollStudentDataStore.read()
    );
    this._result = this.ngPollResultsServant.reportPollResults(this._result);
    this._showResults = {
      hasResources: !_4.isEmpty(this._result.resource),
      showResults: _4.result(this.ngPollDataStore.read().poll, 'show_results_page', false)
    };

    return this;
  }

  get result(): any {
    return this._result;
  }

  get resultsPageFlags(): {
    hasResources: boolean;
    showResults: boolean;
  } {
    return this._showResults;
  }

  get resourceIds(): Array<number | string> {
    return this._resourceIds;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/queries/poll_results_query_model.ts